import { Button, Col, Descriptions, Row, Space } from 'antd';
import Layout from 'antd/lib/layout/layout';
import { EmailInvitation, EmailInvitationStatus } from '../../modules/auth';

interface PartnerRegistrationComponentProps {
  emailInvitation: EmailInvitation;
  postPartnerRegistration: (status: EmailInvitationStatus) => void;
}
function PartnerRegistrationComponent({
  emailInvitation,
  postPartnerRegistration,
}: PartnerRegistrationComponentProps) {
  return (
    <>
      <Layout style={{ padding: '40px', background: '#fff' }}>
        <Row justify="center">
          <Col span={12}>
            <h1>거래처 등록 여부를 선택 하세요.</h1>
          </Col>
        </Row>
        <Row justify="center">
          <Col span={12}>
            <Descriptions
              title="요청한 회사정보"
              bordered
              column={2}
              size="middle"
            >
              <Descriptions.Item label="회사명">
                {emailInvitation.enterprise?.name}
              </Descriptions.Item>
              <Descriptions.Item label="대표명">
                {emailInvitation.enterprise?.representative}
              </Descriptions.Item>
              <Descriptions.Item label="사업자등록번호">
                {emailInvitation.enterprise?.corporateNumber}
              </Descriptions.Item>
              <Descriptions.Item label="주소">
                {emailInvitation.enterprise?.address}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>

        <Row justify="center" style={{ marginTop: '20px' }}>
          <Col span={12}>
            <Descriptions title="수신자 정보" bordered column={2} size="middle">
              <Descriptions.Item label="회사명">
                {emailInvitation.companyName}
              </Descriptions.Item>
              <Descriptions.Item label="대표명">
                {emailInvitation.userName}
              </Descriptions.Item>
            </Descriptions>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: '20px' }}>
          <Col span={12}>
            <Row justify="end">
              <Col>
                <Space size="middle">
                  <Button
                    onClick={() =>
                      postPartnerRegistration(EmailInvitationStatus.DECLINED)
                    }
                    danger
                  >
                    거절
                  </Button>
                  <Button
                    onClick={() =>
                      postPartnerRegistration(EmailInvitationStatus.ACCEPTED)
                    }
                    type="primary"
                  >
                    수락
                  </Button>
                </Space>
              </Col>
            </Row>
          </Col>
          <Col></Col>
        </Row>
      </Layout>
    </>
  );
}

export default PartnerRegistrationComponent;
